var _defs, _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgMoowplayLogo(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    "data-name": "Layer 1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 734.1 141.99",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:#1599bb;}.cls-2{fill:#fff;}"))), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "Moow_for_web") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M147.23,30.45H163l21.93,44.89,21.92-44.89h15.66v74.7H206.85V56.55l-17.4,35.73h-9L162.89,56.55v48.6H147.23Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M225.06,69q0-20.19,9-29.52t27.32-9.34q18.31,0,27.31,9.34t9,29.52q0,38.16-36.3,38.16T225.06,69Zm51.73,18.73q5-6.09,5-18.73,0-13.8-4.87-19.66t-15.54-5.86q-10.68,0-15.55,5.86T241,69q0,12.64,5,18.73t15.43,6.09Q271.81,93.77,276.79,87.68Z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M301.55,69.35q0-20.19,9-29.52t27.32-9.34q18.33,0,27.32,9.34t9,29.52q0,38.16-36.31,38.16T301.55,69.35Zm51.74,18.73q5-6.09,5-18.73,0-13.8-4.87-19.66t-15.55-5.86q-10.67,0-15.54,5.86t-4.87,19.66q0,12.65,5,18.73t15.43,6.09Q348.3,94.17,353.29,88.08Z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M452,106.26H436.23L414.3,61.37l-21.92,44.89H376.72V31.55h15.66V80.16l17.4-35.73h9.05l17.51,35.73V31.55H452Z"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M134.12,71.18A62.88,62.88,0,1,1,71.24,8.3,62.88,62.88,0,0,1,134.12,71.18Z"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M29.93,54.36v28.8c0,11.58,18,11.6,18,0V54.36c0-11.59-18-11.61-18,0Z"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M57.53,45.72V91.8c0,11.58,18,11.6,18,0V45.72c0-11.59-18-11.6-18,0Z"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M85.13,37.08v63.36c0,11.58,18,11.6,18,0V37.08c0-11.59-18-11.61-18,0Z"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M458,31.14h35.48q12.81,0,19.39,7.17t6.58,18.91a27.53,27.53,0,0,1-3.23,13.52A22.48,22.48,0,0,1,507,79.85a29.1,29.1,0,0,1-14,3.23H473.83v23.73H458ZM489.69,70.5q6.71,0,10.23-3.52t3.52-9.76q0-6.57-3.29-10t-9.87-3.47H473.83V70.5Z"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M528.24,31.14H544.1V94.59h37.25v12.22H528.24Z"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M614.84,31.14h17.39L661,106.81H644.57L637.4,88.6H609.55l-7,18.21H585.93Zm20.21,45.24L623.42,45.94,611.9,76.38Z"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M683.35,78.85,656.21,31.14h16.57l18.56,34.19,18.57-34.19h16.45L699.22,78.85v28H683.35Z"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgMoowplayLogo);
export default __webpack_public_path__ + "static/media/Moowplay_logo.9a1f194e7b07e947628b7f3e75ef7247.svg";
export { ForwardRef as ReactComponent };